import type { IntrinsicElementWithoutStyles } from '@oracle/oraclejet-internal-utilities/typeUtils';
import * as css from './styles.css';

const DemoContainer = (props: IntrinsicElementWithoutStyles<'div'>) => (
  <div {...props} className={css.container} />
);

const DemoWrapper = (props: IntrinsicElementWithoutStyles<'div'>) => (
  <div {...props} className={css.wrapper} />
);

export { DemoContainer, DemoWrapper };
